
import { ScheduleItem } from '@/integrations/supabase/client';

export const keynotes: ScheduleItem[] = [
  {
    id: "3",
    day: "day1",
    start_time: "10:00",
    end_time: "10:20",
    title: "Keynote IV: From Data to Intelligence: The Oracle Blueprint for Enterprise AI",
    description: null,
    location: "Main Hall",
    type: "Keynote",
    speaker: { name: "Tejas Joshi, CTO Data Platform & AI, Oracle" }
  },
  {
    id: "4",
    day: "day1",
    start_time: "10:50",
    end_time: "11:10",
    title: "Keynote V: Data, Sorted! – How to Turn Mayhem into Insight",
    description: null,
    location: "Main Hall",
    type: "Keynote",
    speaker: { name: "Oliver King-Smith, CEO, SMARTR.AI" }
  },
  {
    id: "6",
    day: "day1",
    start_time: "11:10",
    end_time: "11:30",
    title: "Keynote VI: Scaling AI Agents for the Enterprise",
    description: null,
    location: "Main Hall",
    type: "Keynote",
    speaker: { name: "David Groves, Strategic AI Lead & Principal Data Scientist - AI & Analytics, IBM" }
  }
];
